import React, { FC } from "react";

export type SponsorLogoProps = {
  src: string | undefined;
};

export const SponsorLogo: FC<SponsorLogoProps> = ({ src }) => {
  return (
    <div className="sponsor-logo">
      <img src={src ?? "/assets/img/icecompass_tiny.png"} alt="sponsor logo" />
    </div>
  );
};
